// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SEO_BABY = "Bazar";
export const REVIEWS_OF_THE_SELLER_username = "Hodnocen\u00ed prodejce %(username)s";
